export default __webpack_public_path__ + "static/media/ptl_logo_earth_wide_blue.66e96a6a.svg";